import { createAsyncActionTypes, createAction } from '@mews/framework';
import { prefix } from './module';

export const PAGINATION_CREATED = prefix('PAGINATION_CREATED');
export const PAGINATION_IDS_CHANGED = prefix('PAGINATION_IDS_CHANGED');
export const PAGE_CHANGED = prefix('PAGE_CHANGED');

const PAGE_FETCH = prefix('PAGE_FETCH');
export const [PAGE_FETCH_STARTED, PAGE_FETCH_SUCCEEDED, PAGE_FETCH_FAILED] = createAsyncActionTypes(PAGE_FETCH);

export const createPagination = (ids: $TSFixMe, pageSize: $TSFixMe, scope: $TSFixMe) =>
    createAction(PAGINATION_CREATED, { ids, pageSize }, { scope });

export const createAsyncPagination = (pageSize: $TSFixMe, scope: $TSFixMe) =>
    createAction(PAGINATION_CREATED, { pageSize }, { scope });

export const changePage = (page: $TSFixMe, scope: $TSFixMe) => createAction(PAGE_CHANGED, page, { scope });

export const pageFetchStarted = (scope: $TSFixMe) => createAction(PAGE_FETCH_STARTED, undefined, { scope });

export const pageFetchSucceeded = (page: number, ids: Array<string>, totalCount: number, scope: string) =>
    createAction(PAGE_FETCH_SUCCEEDED, { page, ids, totalCount }, { scope });

export const pageFetchFailed = (scope: $TSFixMe) => createAction(PAGE_FETCH_FAILED, undefined, { scope });

export const changePaginationIds = (ids: $TSFixMe, scope: $TSFixMe) =>
    createAction(PAGINATION_IDS_CHANGED, { ids }, { scope });
